import { ThemeContext } from "../../context/ThemeContext";
import React, { useContext } from "react";

const DarkModeToggle = () => {
  const { state, dispatch } = useContext(ThemeContext);
  console.log(state);

  return (
    <div
      className="container"
      onClick={() => dispatch({ type: "CHANGE_THEME" })}
    >
      <div className="icon">🌙</div>
      <div className="icon">🌞</div>
      <div
        className="ball"
        style={state.theme === "light" ? { left: "2px" } : { right: "2px" }}
      />
    </div>
  );
};

export default DarkModeToggle;
